const styles = theme => ({
  nav: {
    minWidth: '30vw',
    background: '#333',
    flex: 1,
    paddingBottom: '40px',
    '& a': {
      textDecoration: 'none'
    },
    '& a:hover': {
      textDecoration: 'underline',
      textDecorationColor: 'rgba(255,255,255,.7)',
      textUnderlinePosition: 'under',
      '& p': {
        color: 'rgba(255,255,255,.7)'
      }
    }
  },
  navLogo: {
    height: 50,
    margin: '3rem 0 1rem 3rem'
  },
  navItems: {
    marginLeft: '3rem'
  },
  navItem: {
    color: 'rgba(255,255,255,.5)',
    textTransform: 'uppercase',
    margin: theme.spacing.unit,
    fontWeight: 800,
    '& img': {
      verticalAlign: 'middle',
      height: 35,
      marginRight: 20
    }
  },
  navDatascience: {
    color: theme.brand && theme.brand.datascience.navText
  },
  navDevelop: {
    color: theme.brand && theme.brand.develop.navText
  },
  navDevops: {
    color: theme.brand && theme.brand.devops.navText
  },
  navDynamics: {
    color: theme.brand && theme.brand.dynamics_365.navText
  },
  navTaas: {
    color: theme.brand && theme.brand.taas.navText
  },
  navFixed: {
    color: theme.brand && theme.brand.fixed.navText,
    marginBottom: theme.spacing.unit * 3
  },
  navFooter: {
    background: '#333',
    padding: '3rem',
    '& img': {
      width: 100
    }
  },
  divider: {
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
    border: 'none',
    borderTop: '1px solid #444',
    width: '70%'
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/nav/styles.js